import {
    ShortestTimelineItem,
    TimelineConnector,
    TimelineContent,
    TimelineOppositeContent,
} from "../TimelineItem.styles";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { TimelineEnd } from "../GameTimeline.styles";
import React from "react";

export function MatchBreakStartEvent() {
    return (
        <ShortestTimelineItem>
            <TimelineOppositeContent />
            <TimelineSeparator>
                <TimelineEnd />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent />
        </ShortestTimelineItem>
    );
}
